// extracted by mini-css-extract-plugin
export default {"cartContainer":"ER","summarycontent":"FR","offset":"GR","leaf":"HR","summaryclosed":"IR","summaryheader":"JR","summaryitems":"KR","summaryprice":"LR","buttonopen":"MR","buttondown":"NR","summaryfixed":"OR","usdnotification":"PR","renew":"QR","promowrapper":"RR","ordersummarywrap":"SR","simplewrap":"TR"};
    if(module.hot) {
      // 1737143663093
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  